import { Typography } from "@mui/material";

const NumberInputField = ({ value, onChange, placeholder, error, readOnly, color }) => (
  <>
    <input
      type="number"
      placeholder={placeholder || "e.g., 23"}
      style={{
        border: '1px solid #b8bdc9',
        borderRadius: '3px',
        padding: '10px',
        userSelect: 'text',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        width: '100%',
        fontSize: '12px',
        fontWeight: 700,
        lineHeight: 1.45,
        color,
        marginBottom: '8px'
      }}
      readOnly={readOnly}
      value={value}
      onChange={onChange}
    />
    {error && (
      <Typography variant="subtitle1" color="#FF0000" fontWeight={700}>
        {error}
      </Typography>
    )}
  </>
);

export default NumberInputField;
